import { useCallback, FormEvent } from "react";

export default function useFormOnSubmit(
  onSubmit: () => void
): (event: FormEvent<HTMLFormElement>) => void {
  const handler = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onSubmit();
    },
    [onSubmit]
  );

  return handler;
}
